import { Gql } from "@api/Api";
export const sortOrderToDirection = (sortOrder: Gql.SortOrder) => {
    switch (sortOrder) {
        case Gql.SortOrder.ASC:
            return "asc";
        case Gql.SortOrder.DESC:
            return "desc";
    }
};
